module.exports = __webpack_public_path__ + "static/media/dragdrop.ebbfca10.svg";